export default class EventDispatcher {
    constructor(sticky) {
        this.events = {};
        this.lastEvent;
        this.sticky = sticky || false;
    }

    setEventTypes(arr) {
        arr.forEach(v => this.events[v] = []);
    }

    // event stub   
    addEventListener(event, listener) {
        if (this.events[event] !== undefined && typeof (listener) === 'function') {
            this.events[event].push(listener);
            if (this.sticky && this.lastEvent && this.lastEvent.event === event) {
                listener(event, this.lastEvent.data);
            }
        }
    }

    removeEventListener(event, listener) {
        const idx = this.events[event] === undefined ? -1 : this.events[event].indexOf(listener);
        if (idx !== -1) {
            this.events[event].splice(idx, 1);
        }
    }

    dispatch(event, data) {
        if (this.events[event] !== undefined) {
            if (this.sticky) {
                this.lastEvent = {
                    event, data
                };
            }
            let fLength = this.events[event].length;
            for (let i = 0; i < fLength; i++) {
                this.events[event][i](event, data);
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/js/studio/service/EventDispatcher.js